import React, { Component } from "react";
import { Jumbotron as Jumbo, Container } from 'react-bootstrap';
import styled from 'styled-components'
import img from '../assets/xsell_img1.png'

const Styles = styled.div`
    .jumbo {
        background: center url(${img});
        background-size: contain;
        color: #efefef;
        height: 100px;
        position: relative;
        border-radius: 0;
        width: 100%
    }

    .overlay {
        background-color: #000;
        opacity: 0.6;
        position: relative;
        
    }

    .title {
        color: white;
    }
`

export const Jumbotron = () => (

    <Styles>
        <Jumbo className="jumbo">
            {/* <div className="overlay"></div> */}
            <Container>
                <h1 className="title">X-Sell</h1>
            </Container>
        </Jumbo>
    </Styles>

)